import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = ({ onLogout }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear token from localStorage
    localStorage.removeItem('token');
    onLogout(); // Update the isAuthenticated state in App.js
    navigate('/login'); // Redirect to the login page
  }, [navigate, onLogout]);

  return null; // No need to render anything
};

export default Logout;
